// Demo data per sezione venditore - InLeads
// Dati completamente simulati per scopi dimostrativi

export const demoAgencyData = {
  nome_agenzia: "Immobiliare Roma Centro",
  zona: "Roma EUR",
  tipo_account: "premium",
  stats: {
    match_attivi: 25,
    colloqui_fissati: 12,
    inseriti: 4,
    candidati_totali: 47,
    tasso_conversione: 32
  }
};

export const demoCandidates = [
  {
    id: "demo-1",
    nome: "Marco",
    cognome: "Rossi", 
    eta: 28,
    zona_interesse: "Roma EUR",
    anni_esperienza: 3,
    esperienza_flag: true,
    stato_match: "in_attesa_contatto",
    score: 92,
    telefono: "+39 333 1234567",
    email: "marco.rossi.demo@inleads.it",
    note_agenzia: "",
    foto: "MR"
  },
  {
    id: "demo-2", 
    nome: "Giulia",
    cognome: "Bianchi",
    eta: 25,
    zona_interesse: "Roma Centro", 
    anni_esperienza: 1,
    esperienza_flag: true,
    stato_match: "chiamato",
    score: 88,
    telefono: "+39 333 2234567",
    email: "giulia.bianchi.demo@inleads.it",
    note_agenzia: "Candidata molto motivata, esperienza in vendita retail",
    foto: "GB"
  },
  {
    id: "demo-3",
    nome: "Alessandro", 
    cognome: "Ferrari",
    eta: 32,
    zona_interesse: "Roma Sud",
    anni_esperienza: 5,
    esperienza_flag: true,
    stato_match: "colloquio_fissato", 
    score: 95,
    telefono: "+39 333 3234567",
    email: "alessandro.ferrari.demo@inleads.it",
    note_agenzia: "Esperienza consolidata, ottime referenze precedenti",
    data_colloquio: "2024-10-15",
    foto: "AF"
  },
  {
    id: "demo-4",
    nome: "Francesca",
    cognome: "Romano",
    eta: 29,
    zona_interesse: "Roma Nord",
    anni_esperienza: 2,
    esperienza_flag: true,
    stato_match: "in_attesa_contatto",
    score: 85,
    telefono: "+39 333 4234567", 
    email: "francesca.romano.demo@inleads.it",
    note_agenzia: "",
    foto: "FR"
  },
  {
    id: "demo-5",
    nome: "Lorenzo",
    cognome: "Conti",
    eta: 26,
    zona_interesse: "Roma EUR",
    anni_esperienza: 0,
    esperienza_flag: false,
    stato_match: "chiamato",
    score: 78,
    telefono: "+39 333 5234567",
    email: "lorenzo.conti.demo@inleads.it", 
    note_agenzia: "Neolaureato in economia, molto determinato",
    foto: "LC"
  }
];

export const demoAgencies = [
  {
    id: "agenzia-demo-1",
    nome_agenzia: "Tecnocasa Roma EUR",
    zona: "Roma EUR", 
    descrizione: "Agenzia leader nel quartiere EUR con 15 anni di esperienza",
    stato_match: "in_attesa_contatto",
    score: 90,
    posti_disponibili: 3,
    tipo_contratto: "Agente d'affari in mediazione",
    logo: "TR"
  },
  {
    id: "agenzia-demo-2",
    nome_agenzia: "Re/Max Roma Centro",
    zona: "Roma Centro",
    descrizione: "Network internazionale, formazione continua e supporto marketing",
    stato_match: "chiamato", 
    score: 94,
    posti_disponibili: 2,
    tipo_contratto: "Collaboratore",
    logo: "RM",
    nota_candidato: "Molto interessato alla formazione offerta"
  },
  {
    id: "agenzia-demo-3",
    nome_agenzia: "Coldwell Banker Roma",
    zona: "Roma Nord",
    descrizione: "Prestigio internazionale, clientela di alto livello",
    stato_match: "colloquio_fissato",
    score: 96,
    posti_disponibili: 1,
    tipo_contratto: "Agente immobiliare",
    logo: "CB",
    data_colloquio: "2024-10-12"
  },
  {
    id: "agenzia-demo-4", 
    nome_agenzia: "Casa.it Roma Sud",
    zona: "Roma Sud",
    descrizione: "Innovazione digitale e strumenti tecnologici avanzati",
    stato_match: "in_attesa_contatto",
    score: 87,
    posti_disponibili: 4,
    tipo_contratto: "Agente d'affari",
    logo: "CI"
  },
  {
    id: "agenzia-demo-5",
    nome_agenzia: "Immobiliare.it Roma",
    zona: "Roma Centro",
    descrizione: "Leader nel digitale immobiliare, piattaforma integrata",
    stato_match: "chiamato",
    score: 91, 
    posti_disponibili: 2,
    tipo_contratto: "Collaboratore digitale",
    logo: "II",
    nota_candidato: "Interessante opportunità nel settore digital"
  }
];

export const demoFeedPosts = [
  {
    id: "feed-1",
    agenzia: "Tecnocasa Roma EUR",
    logo: "TR",
    tipo: "successo",
    contenuto: "🎯 3 nuovi colloqui fissati questa settimana con candidati motivati di Roma Sud! Il nostro metodo di selezione InLeads ci sta dando risultati eccellenti.",
    timestamp: "2h fa",
    likes: 24,
    commenti: 8,
    zona_target: "Roma Sud"
  },
  {
    id: "feed-2", 
    agenzia: "Re/Max Roma Centro",
    logo: "RM",
    tipo: "formazione",
    contenuto: "📚 Nuovo corso di formazione gratuito: 'Tecniche di vendita digitale nel mercato immobiliare 2024'. Iscriviti ora - solo per agenti Roma Centro!",
    timestamp: "4h fa", 
    likes: 31,
    commenti: 12,
    zona_target: "Roma Centro"
  },
  {
    id: "feed-3",
    agenzia: "Coldwell Banker Roma", 
    logo: "CB",
    tipo: "opportunita",
    contenuto: "✨ Aperta nuova sede a Roma Nord! Cerchiamo 2 agenti senior per clientela luxury. Pacchetto incentivi molto competitivo.",
    timestamp: "6h fa",
    likes: 18,
    commenti: 5, 
    zona_target: "Roma Nord"
  },
  {
    id: "feed-4",
    agenzia: "Casa.it Roma Sud",
    logo: "CI", 
    tipo: "evento",
    contenuto: "🏆 Il nostro team ha chiuso 25 vendite a Settembre! Complimenti a tutti gli agenti per l'eccellente lavoro di squadra a Roma Sud.",
    timestamp: "1g fa",
    likes: 42,
    commenti: 15,
    zona_target: "Roma Sud"
  }
];

export const demoCandidateData = {
  nome: "Mario",
  cognome: "Verdi", 
  eta: 27,
  zona_interesse: "Roma EUR",
  anni_esperienza: 2,
  esperienza_flag: true,
  telefono: "+39 333 9876543",
  email: "mario.verdi.demo@inleads.it"
};

export const demoStats = {
  candidato: {
    opportunita_attive: 5,
    agenzie_interessate: 3, 
    colloqui_fissati: 1,
    tasso_risposta: 85
  },
  agenzia: {
    candidati_totali: 47,
    match_attivi: 25,
    colloqui_questa_settimana: 12,
    inseriti_questo_mese: 4,
    tasso_conversione: 32
  }
};

// Funzioni helper per simulazioni
export const simulateApiCall = (data, delay = 500) => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(data), delay);
  });
};

export const getRandomScore = () => {
  return Math.floor(Math.random() * (98 - 75) + 75);
};

// Demo Messaggi
export const demoMessaggi = {
  agenzia: [
    {
      id: "msg-1",
      contatto: "Marco Rossi",
      ultima_msg: "Buongiorno, sono interessato alla posizione di agente immobiliare",
      timestamp: "10:30",
      non_letti: 2,
      foto: "MR",
      tipo: "candidato"
    },
    {
      id: "msg-2", 
      contatto: "Giulia Bianchi",
      ultima_msg: "Perfetto! Quando possiamo fissare il colloquio?",
      timestamp: "ieri",
      non_letti: 0,
      foto: "GB",
      tipo: "candidato"
    },
    {
      id: "msg-3",
      contatto: "Supporto InLeads",
      ultima_msg: "Il tuo profilo agenzia è stato approvato! 🎉",
      timestamp: "2g fa",
      non_letti: 1,
      foto: "AP",
      tipo: "sistema"
    }
  ],
  candidato: [
    {
      id: "msg-c1",
      contatto: "Tecnocasa Roma EUR",
      ultima_msg: "Ciao Mario! Ti abbiamo selezionato per un colloquio",
      timestamp: "14:20",
      non_letti: 3,
      foto: "TR",
      tipo: "agenzia"
    },
    {
      id: "msg-c2",
      contatto: "Re/Max Roma Centro", 
      ultima_msg: "Grazie per il tuo interesse. Ti ricontatteremo presto!",
      timestamp: "ieri",
      non_letti: 0,
      foto: "RM",
      tipo: "agenzia"
    },
    {
      id: "msg-c3",
      contatto: "Supporto InLeads",
      ultima_msg: "Benvenuto su InLeads! Ecco come iniziare... 📚",
      timestamp: "3g fa",
      non_letti: 0,
      foto: "AP",
      tipo: "sistema"
    }
  ]
};

// Demo Notifiche
export const demoNotifiche = {
  agenzia: [
    {
      id: "not-1",
      tipo: "nuovo_candidato",
      titolo: "Nuovo candidato compatibile",
      messaggio: "Alessandro Ferrari (95% compatibilità) è interessato alla tua agenzia",
      timestamp: "5 min fa",
      letta: false,
      icona: "user-plus",
      colore: "blue"
    },
    {
      id: "not-2",
      tipo: "colloquio_confermato",
      titolo: "Colloquio confermato",
      messaggio: "Marco Rossi ha confermato il colloquio per domani alle 15:00",
      timestamp: "2h fa", 
      letta: false,
      icona: "calendar-check",
      colore: "green"
    },
    {
      id: "not-3",
      tipo: "feedback_ricevuto",
      titolo: "Nuovo feedback candidato",
      messaggio: "Giulia Bianchi ha lasciato un feedback positivo sul colloquio",
      timestamp: "1g fa",
      letta: true,
      icona: "star",
      colore: "yellow"
    }
  ],
  candidato: [
    {
      id: "not-c1",
      tipo: "contatto_agenzia",
      titolo: "Sei stato contattato!",
      messaggio: "Tecnocasa Roma EUR ti ha selezionato. Controlla i messaggi!",
      timestamp: "1h fa",
      letta: false,
      icona: "phone",
      colore: "green"
    },
    {
      id: "not-c2", 
      tipo: "nuovo_match",
      titolo: "Nuova opportunità",
      messaggio: "Casa.it Roma Sud è interessata al tuo profilo (87% compatibilità)",
      timestamp: "3h fa",
      letta: false,
      icona: "briefcase",
      colore: "blue"
    },
    {
      id: "not-c3",
      tipo: "post_agenzia",
      titolo: "Nuovo post nella tua zona",
      messaggio: "Re/Max Roma Centro ha pubblicato un nuovo evento formativo",
      timestamp: "6h fa",
      letta: true,
      icona: "megaphone",
      colore: "purple"
    }
  ]
};

// Demo Post Video e Contenuti
export const demoPostVideo = [
  {
    id: "video-1",
    autore: "Tecnocasa Roma EUR",
    logo: "TR",
    tipo: "video",
    titolo: "Come abbiamo raggiunto 50 vendite questo mese",
    descrizione: "Scopri le strategie che ci hanno portato al record di vendite. Tecniche, strumenti e mindset vincente!",
    thumbnail: "https://via.placeholder.com/400x225/3B82F6/FFFFFF?text=Video+Tutorial",
    durata: "3:45",
    views: 245,
    likes: 34,
    timestamp: "2h fa",
    zona_target: "Roma EUR"
  },
  {
    id: "video-2",
    autore: "Re/Max Roma Centro",
    logo: "RM", 
    tipo: "video",
    titolo: "Evento formativo: Vendere nel mercato digitale 2024",
    descrizione: "Registrazione del nostro ultimo webinar sulle nuove strategie di vendita immobiliare online",
    thumbnail: "https://via.placeholder.com/400x225/10B981/FFFFFF?text=Webinar+Live",
    durata: "12:30",
    views: 1200,
    likes: 89,
    timestamp: "1g fa",
    zona_target: "Roma Centro"
  },
  {
    id: "post-1",
    autore: "Coldwell Banker Roma",
    logo: "CB",
    tipo: "immagine",
    titolo: "Team building di successo! 🎉",
    descrizione: "Il nostro team ha chiuso 25 contratti questo mese. Complimenti a tutti gli agenti per l'incredibile lavoro di squadra!",
    immagine: "https://via.placeholder.com/400x300/8B5CF6/FFFFFF?text=Team+Success",
    likes: 156,
    commenti: 23,
    timestamp: "4h fa",
    zona_target: "Roma Nord"
  }
];

export const formatTimestamp = (hours) => {
  if (hours < 24) return `${hours}h fa`;
  const days = Math.floor(hours / 24);
  return `${days}g fa`;
};